import React from "react";
import CountAnimation from "../../components/Unique/Animation/Count-up.tsx";

function Kpi({ children, header, number, percentage, mode, percentageRef }) {
  return (
    <div className={`kpi ${mode === "light" ? "lightr" : "darkr"} shadow-md dark:border-white`}>
      <div className="kpi-header">
        <div>
          <span>{header}</span>
        </div>
      </div>

      <div className={`kpi-body ${mode === "light" ? "" : "dark"}`}>
        <CountAnimation number={number} className="number" />
        <h5>
          <div className={`percentage ${percentage >= 0 ? "green" : "red"}`} ref={percentageRef}>
            {typeof percentage === "number" && !isNaN(percentage)
              ? (percentage > 0 ? `+${percentage.toFixed(2)}%` : `${percentage.toFixed(2)}%`)
              : "--"}
          </div>
        </h5>
        {children}
      </div>
    </div>
  );
}

export default Kpi;
